import { render, staticRenderFns } from "./CommunityHCImage.vue?vue&type=template&id=516d3989&scoped=true"
import script from "./CommunityHCImage.vue?vue&type=script&lang=js"
export * from "./CommunityHCImage.vue?vue&type=script&lang=js"
import style0 from "./CommunityHCImage.vue?vue&type=style&index=0&id=516d3989&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "516d3989",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('516d3989')) {
      api.createRecord('516d3989', component.options)
    } else {
      api.reload('516d3989', component.options)
    }
    module.hot.accept("./CommunityHCImage.vue?vue&type=template&id=516d3989&scoped=true", function () {
      api.rerender('516d3989', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Decoration/PageDecoration/formList/CommunityHCImage.vue"
export default component.exports